var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.486,
    height: 25.284,
    viewBox: "0 0 42.486 25.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13021",
    d: "M19.911-408.407c-7.019.407-13.64 4.165-18.917 10.736-1.377 1.717-1.377 2.024.008 3.758 5.269 6.579 11.914 10.33 18.967 10.72 7.973.431 15.515-3.335 21.447-10.728 1.377-1.717 1.377-2.024-.008-3.758a28.57 28.57 0 0 0-13.49-9.721 21.879 21.879 0 0 0-4.97-.962 21.3 21.3 0 0 0-3.037-.045zm3.053 3.866a9.059 9.059 0 0 1 5.916 4.19 8.881 8.881 0 0 1 .42 8.251 8.387 8.387 0 0 1-1.734 2.5A8.888 8.888 0 0 1 13-392.286a9.025 9.025 0 0 1-.041-6.911 9.116 9.116 0 0 1 4.937-4.879 8.929 8.929 0 0 1 5.069-.465z",
    transform: "translate(.037 408.444)",
    style: {
      fill: "#5c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13022",
    d: "M202.488-313.608a4.988 4.988 0 0 0-3.227 2.273 4.113 4.113 0 0 0-.664 2.456 4.073 4.073 0 0 0 .473 2.157 5.679 5.679 0 0 0 2.141 2.132 4.829 4.829 0 0 0 6.72-2.838 5.311 5.311 0 0 0 .017-2.9 4.783 4.783 0 0 0-4.381-3.327 5.566 5.566 0 0 0-1.079.047z",
    transform: "translate(-182.117 321.527)",
    style: {
      fill: "#f37b89"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d01f62c440640cad06d5211fcaec31bc.svg";
export { ForwardRef as ReactComponent };